/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Dialog as PaperDialog,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const Title = (props: React.ComponentProps<typeof PaperDialog.Title>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <PaperDialog.Title
      {...props}
      style={[styles.container, props.style]}
    >
      {props.children}
    </PaperDialog.Title>
  );
};

export default Title;
